import BasicFieldParser from './BasicFieldParser.js'
import ComparatorParser from './ComparatorParser.js'
import ConstantNumberFieldParser from './ConstantNumberFieldParser.js'
import ConstantStringFieldParser from './ConstantStringFieldParser.js'
import FunctionFieldParser from './FunctionFieldParser.js'
import LogicalFieldParser from './LogicalFieldParser.js'
import MathFieldParser from './MathFieldParser.js'
import RootFieldParser from './RootFieldParser.js'
import WindowFieldParser from './WindowFieldParser.js'
import ConstantNullFieldParser from './ConstantNullFieldParser.js'
import ListFieldParser from './ListFieldParser.js'
import ConstantBooleanFieldParser from './ConstantBooleanFieldParser.js'
import OrderFieldParser from './OrderFieldParser.js'
import ExtractFromParser from './ExtractFromParser.js'

export default {
  install : ( plugins ) => {
    plugins.addPlugin( 'Expression.FieldParser', RootFieldParser )
    plugins.addPlugin( 'Expression.FieldParser', BasicFieldParser )
    plugins.addPlugin( 'Expression.FieldParser', WindowFieldParser )
    plugins.addPlugin( 'Expression.FieldParser', FunctionFieldParser )
    plugins.addPlugin( 'Expression.FieldParser', MathFieldParser )
    plugins.addPlugin( 'Expression.FieldParser', ConstantNumberFieldParser )
    plugins.addPlugin( 'Expression.FieldParser', ComparatorParser )
    plugins.addPlugin( 'Expression.FieldParser', LogicalFieldParser )
    plugins.addPlugin( 'Expression.FieldParser', ConstantStringFieldParser )
    plugins.addPlugin( 'Expression.FieldParser', ConstantNullFieldParser )
    plugins.addPlugin( 'Expression.FieldParser', ListFieldParser )
    plugins.addPlugin( 'Expression.FieldParser', ConstantBooleanFieldParser )
    plugins.addPlugin( 'Expression.FieldParser', OrderFieldParser )
    plugins.addPlugin( 'Expression.FieldParser', ExtractFromParser )
  }
}
